import { FC } from "react";

import {
  applyOpacityToHexColor,
  FontIcon,
  noWrap,
  Stack,
  Text,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  TooltipHost,
  TooltipOverflowMode,
  useTheme
} from "@bps/fluent-ui";

interface LocationOptionProps {
  color: string | undefined;
  text: string;
  disabled?: boolean;
  showIcon?: boolean;
  showInactiveBadge?: boolean | undefined;
  showDefaultLocationBadge?: boolean;
}
export const LocationOption: FC<LocationOptionProps> = ({
  color,
  text,
  disabled,
  showIcon = true,
  showInactiveBadge = false,
  showDefaultLocationBadge = false
}) => {
  const theme = useTheme();
  const getIconColor = () => {
    if (disabled) {
      return applyOpacityToHexColor(color ?? theme.palette.neutralTertiary, 25);
    } else if (showInactiveBadge) {
      return theme.palette.neutralSecondaryAlt;
    }
    return color;
  };

  return (
    <Stack
      horizontal
      horizontalAlign="space-between"
      styles={{ root: { ...noWrap, flex: 1 } }}
      tokens={{ childrenGap: 8 }}
    >
      <Stack
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: 4 }}
        styles={{ root: { ...noWrap } }}
      >
        {showIcon && (
          <FontIcon
            iconName="LocationFill"
            styles={{ root: { color: getIconColor() } }}
          />
        )}
        <Text
          nowrap
          styles={{
            root: {
              color: disabled ? theme.semanticColors.disabledText : "inherit"
            }
          }}
        >
          <TooltipHost
            overflowMode={TooltipOverflowMode.Self}
            content={text}
            styles={{
              root: {
                display: "block",
                ...noWrap
              }
            }}
          >
            {text}
          </TooltipHost>
        </Text>
      </Stack>
      <Stack horizontal horizontalAlign="end" verticalAlign="center">
        {showInactiveBadge && (
          <TextBadge
            badgeColor={TextBadgeColor.grey}
            badgeSize={TextBadgeSize.small}
          >
            Inactive
          </TextBadge>
        )}
        {showDefaultLocationBadge && (
          <TextBadge
            badgeColor={TextBadgeColor.blue}
            badgeSize={TextBadgeSize.small}
            styles={{ root: { flexGrow: 1 } }}
          >
            Default
          </TextBadge>
        )}
        {disabled && <span>(in use)</span>}
      </Stack>
    </Stack>
  );
};
